import { getScreenWidth } from "../../../../constants";

const YouTubeIframe = ({ url }: { url: string }) => {
  const { isMobile, isDesktop, isTwoColumn } = getScreenWidth();

  const iframeStyle = () => {
    const num = isMobile ? 190 : isDesktop ? 600 : isTwoColumn ? 450 : 330;
    return {
      width: `100%`,
      height: `${num}px`,
    };
  };

  return <iframe src={url} style={iframeStyle()}></iframe>;
};

export default YouTubeIframe;
